import axios from 'axios';
import Config from '../../misc/Config';

const API_URL = Config.GFU_API_URL + '/contacts';
const filter = (filter) => (filter) ? '&filter=' + filter : '';
const state = {
    customers: [],
    customer: null,
    isBusy: false,
};
const getters = {
    customers: (state) => state.customers,
    customer: (state) => state.customer    
};
const actions = {
    /**
     * @todo remove wird nirgendwo benutzt
     */
    async fetchCustomers({ commit }, search) {
        const response = await axios.get(API_URL + '?expand=company' + filter(search));      
        commit('setCustomers', response.data.items);
    },
    /**
     * @todo remove wird nirgendwo benutzt
     */
    async fetchCustomer({ commit }, id) {
        const response = await axios.get(API_URL + '/' + id + '/by-ref?expand=company')
        commit('setCustomer', response.data);
    }
};
const mutations = {
    setCustomers: (state, customers) => state.customers = customers,
    setCustomer: (state, customer) => state.customer = customer,
};

export default {
    state,
    getters,
    actions,
    mutations,
}